export default __webpack_public_path__ + "static/media/semcasting-tradedesk-logo.03c5071b.svg";